import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps } from "react-router";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import i18n from "../../../../utils/i18n";
import { SettingIcon, ResearchIcon } from "../../../atoms/icon";
import AppMainCard, { MainCardProp } from "../../../atoms/main-card";

const ITEMS: MainCardProp[] = [
  {
    index: 1,
    name: i18n.t("AssetLiability.staticALM"),
    icon: <ResearchIcon />,
    link: ROUTE_PATHS.StaticALM,
  },
  {
    index: 2,
    name: i18n.t("AssetLiability.dynamicALM"),
    icon: <ResearchIcon />,
    link: ROUTE_PATHS.DynamicALM,
  },
  {
    index: 3,
    name: i18n.t("AssetLiability.stressTesting"),
    icon: <ResearchIcon />,
    link: ROUTE_PATHS.StressTesting,
  },
];

interface Props extends RouteChildrenProps {}

const AssetLiability = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="ecap-leader-wrapper">
      <AppMainCard items={ITEMS} />

      {/* <Button shape="round" type="default" className="setting-btn" >
                <SettingIcon className="svg-icon" /> {t("ECAPLeader.btnConfiguration")}
            </Button> */}
    </div>
  );
};

export default AssetLiability;
